import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

const Roadmap = ({homepagedata}) => {
    const {t} = useTranslation();
    let settings = {
        dots: true,
        arrows: false,
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
              }
            },
            {
                breakpoint: 991,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                }
            },           
        ]
      }; 
    return (            
       

        <section className="RdMpSec" data-aos="fade-down"data-aos-easing="linear" data-aos-duration="1500">
            <div className="container">
                <div className="RdMpDv">
                    <h3>{t('Roadmap')}</h3>
                    <p> {homepagedata?.roadmap_description}</p>
                    <div className="RdMpSldr">
                        <Slider {...settings}>
                            <div className="RdMpSldrInr">
                                <div className="RdMpSldrPrt">
                                    <div className="RdMpSldrDts">
                                        <span>{t('January')} 2025</span>
                                    </div>
                                    <p className="RdMpSldrTpCnt">{t('Start of the ICO Crypto Platform Development')}</p>
                                </div>
                            </div>
                            <div className="RdMpSldrInr">
                                <div className="RdMpSldrPrt">
                                    <div className="RdMpSldrDts RdMpSldrDtsEven">
                                        <span>{t('February')} 2025</span>
                                    </div>
                                    <p className="RdMpSldrBtmCnt">{t('Start of the Preparation for the ICO Token Sale')}</p>
                                </div>
                            </div>
                            <div className="RdMpSldrInr">
                                <div className="RdMpSldrPrt">
                                    <div className="RdMpSldrDts">
                                        <span>{t('March')} 2025</span>
                                    </div>
                                    <p className="RdMpSldrTpCnt">{t('ICO Platform Launched with full Solution')}</p>
                                </div>
                            </div>
                            <div className="RdMpSldrInr">
                                <div className="RdMpSldrPrt">
                                    <div className="RdMpSldrDts RdMpSldrDtsEven">
                                        <span>{t('April')} 2025</span>
                                    </div>
                                    <p className="RdMpSldrBtmCnt">{t('Partnership for the Future Ecosystem')}</p>
                                </div>
                            </div>
                            <div className="RdMpSldrInr">
                                <div className="RdMpSldrPrt">
                                    <div className="RdMpSldrDts">
                                        <span>{t('May')} 2025</span>
                                    </div>
                                    <p className="RdMpSldrTpCnt">{t('ICO Wallet Full Version Release')}</p>
                                </div>
                            </div>
                            <div className="RdMpSldrInr">
                                <div className="RdMpSldrPrt">
                                    <div className="RdMpSldrDts RdMpSldrDtsEven">
                                        <span>{t('June')} 2025</span>
                                    </div>
                                    <p className="RdMpSldrBtmCnt">{t('Partnership for the Future Ecosystem')}</p>
                                </div>
                            </div>
                            <div className="RdMpSldrInr">
                                <div className="RdMpSldrPrt">
                                    <div className="RdMpSldrDts">
                                        <span>{t('July')} 2025</span>
                                    </div>
                                    <p className="RdMpSldrTpCnt">{t('Start of the ICO Crypto Platform Development')}</p>
                                </div>
                            </div>
                            <div className="RdMpSldrInr">
                                <div className="RdMpSldrPrt">
                                    <div className="RdMpSldrDts RdMpSldrDtsEven">
                                        <span>{t('August')} 2025</span>
                                    </div>
                                    <p className="RdMpSldrBtmCnt">{t('Partnership for the Future Ecosystem')}</p>
                                </div>
                            </div>
                            <div className="RdMpSldrInr">
                                <div className="RdMpSldrPrt">
                                    <div className="RdMpSldrDts">
                                        <span>{t('September')} 2025</span>
                                    </div>
                                    <p className="RdMpSldrTpCnt">{t('Start of the ICO Crypto Platform Development')}</p>
                                </div>
                            </div>
                            <div className="RdMpSldrInr">
                                <div className="RdMpSldrPrt">
                                    <div className="RdMpSldrDts RdMpSldrDtsEven">
                                        <span>{t('October')} 2025</span>
                                    </div>
                                    <p className="RdMpSldrBtmCnt">{t('Partnership for the Future Ecosystem')}</p>
                                </div>
                            </div>
                            <div className="RdMpSldrInr">
                                <div className="RdMpSldrPrt">
                                    <div className="RdMpSldrDts">
                                        <span>{t('November')} 2025</span>
                                    </div>
                                    <p className="RdMpSldrTpCnt">{t('Start of the ICO Crypto Platform Development')}</p>
                                </div>
                            </div>
                            <div className="RdMpSldrInr">
                                <div className="RdMpSldrPrt">
                                    <div className="RdMpSldrDts RdMpSldrDtsEven">
                                        <span>{t('December')} 2025</span>
                                    </div>
                                    <p className="RdMpSldrBtmCnt">{t('Partnership for the Future Ecosystem')}</p>
                                </div>
                            </div>
                        </Slider>
                    </div>
                </div>
            </div>
        </section>
    );
   
}
Roadmap.propTypes = {
    homepagedata: PropTypes.shape({
        roadmap_description : PropTypes.any,
    }),
}

export default Roadmap;
